import React from "react";
import { Box, Grid, Link, Typography } from "@mui/material";
import { formatPhoneNumber, getStoreAddress } from "../util";

export default function StoreLocation(props) {
  const { store, index } = props;

  return (
    <Box
      p={2}
      sx={{
        color: "#333",
        backgroundColor: "#F7F7F7",
        borderRadius: "4px",
      }}
    >
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={6}>
          <Box>
            <Typography mb={1} variant="body1" sx={{ fontWeight: "bold" }}>
              {store.name || `${store.address.city} Store`}
            </Typography>
            <Box mb={1}>
              <Typography variant="body1">{store.address.street}</Typography>
              <Typography variant="body1">
                {store.address.city}, {store.address.state} {store.address.zip}
              </Typography>
            </Box>
            <Box mb={1}>
              <Typography variant="body2" color="textSecondary">
                {formatPhoneNumber(store.phone)}
              </Typography>
            </Box>
            <Box>
              <Link
                underline="always"
                color="inherit"
                component="a"
                href={`https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${encodeURIComponent(getStoreAddress(store))}`}
              >
                Directions
              </Link>
              &nbsp;&bull;&nbsp;
              <Link underline="always" color="inherit" href={`tel:${store.phone}`}>
                Call
              </Link>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}
        >
          <Box>
            {store.hours.map((o, idx) => (
              <Box key={idx} sx={{ display: "flex" }}>
                <Box sx={{ width: "40px" }}>
                  <Typography variant="overline">{o.day}:</Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="overline">{o.hours}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
